<script>
import Breadcrumbs from "@/components/global/breadcrumbs.vue";
import ClassForm from "@/components/classes/class_form.vue";

export default {
  name: "NewClassView",

  components: {
    Breadcrumbs,
    ClassForm,
  },

  props: {
    isRedirectAfterCreated: {
      type: Boolean,
      default: true,
    },
  },

  emits: ["input", "close"],

  computed: {
    breadcrumbs() {
      return [
        {
          text: "Classes",
          to: "/classes",
        },
        {
          text: "New Class",
          active: true,
        },
      ];
    },
  },

  methods: {
    handleClose() {
      if (this.$listeners["close"]) {
        this.$emit("close");
      } else {
        this.$router.push("/classes");
      }
    },
  },
};
</script>

<template>
  <eg-b-container>
    <section>
      <breadcrumbs :items="breadcrumbs" />
      <eg-b-row>
        <eg-b-col lg="6">
          <h1>{{ $t("common.newClass") }}</h1>
        </eg-b-col>
      </eg-b-row>
      <class-form
        :is-redirect-after-created="isRedirectAfterCreated"
        @close="handleClose"
        @input="$emit('input', $event)"
      />
    </section>
  </eg-b-container>
</template>
